import { RegistryEntry, RegistrySchemaWithOptions } from "@/services/registries/registriesAPI";
import { SavedObject } from "@/services/commonModels";

export const DEFAULT_EXPERIMENT_SETUP_CONFIG_TYPES = ["target", "crop"];

export type ExperimentSetupRelationshipConfig = {
    experimentGroupId: string | null;
    schemaConfigId: string | null;
    type: string;
    registrySchemaId: string;
    required: boolean;
    allowMultiple: boolean;
    defaultRegistryEntryIds: string[] | null;
};

export type SavedExperimentSetupRelationshipConfig = ExperimentSetupRelationshipConfig & {
    id: string;
};

export type ManageExperimentSetupRelationshipConfigDTO = SavedExperimentSetupRelationshipConfig & {
    registrySchema: {
        id: string;
        displayName: string;
    };
    defaultRegistryEntries: RegistryEntry[] | null;
};

export type RelationshipConfigForExperimentSetup = SavedExperimentSetupRelationshipConfig & {
    registrySchema: RegistrySchemaWithOptions;
    defaultRegistryEntries: RegistryEntry[] | null;
};

export type RelationshipConfigsForType<T extends SavedExperimentSetupRelationshipConfig> = {
    type: string;
    relationshipConfigs: T[];
};

export type ExperimentRelationshipsForSetupDTO = {
    type: string;
    registrySchemaId: string;
    registryEntryIds: string[];
};

export type ExperimentRelationship = {
    experimentId: number;
    registryEntryId: string;
    type: string | null;
};

export type SavedExperimentRelationship = ExperimentRelationship & SavedObject<string>;

export type ExperimentRelationshipDTO = SavedExperimentRelationship & {
    experimentCode: string;
    registrySchemaName: string;
    registryEntry: RegistryEntry;
};

export type ExperimentRelationshipsForType<T extends SavedExperimentRelationship> = {
    type: string;
    relationships: T[];
};
